// extracted by mini-css-extract-plugin
export default {"remove":"bznN7FZ766hzCP1LRQZ8g"};